export default function queryParse(search) {
  const query = search.startsWith('?') ? search.substring(1) : search
  const res = {}
  if (!query) return res
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    res[pair[0]] = decodeURIComponent(pair[1])
  }
  return res
}

export function queryCompile(searchDict) {
  if (!Object.keys(searchDict).length) return ''
  return (
    '?' +
    Object.entries(searchDict)
      .map(items => `${items[0]}=${items[1]}`)
      .join('&')
  )
}

export  const openInNewTab = (path) => {
  const returnUrl = encodeURIComponent(window.location.href);
  const newPath = path.includes('?') ? `${path}&returnUrl=${returnUrl}` : `${path}?returnUrl=${returnUrl}`;
  
  const baseUrl = window.location.origin + window.location.pathname;
  const newUrl = new URL(newPath, baseUrl).href;
  window.open(newUrl, '_blank');
};
